import { calendarConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";


export const check_google_calendar_linked_action = () => async (dispatch) => {
  dispatch({
    type: calendarConstants.CHECK_GOOGLE_CALENDAR_LINKED_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.common.checkGoogleCalendarLinked
    );
    if (response.status) {
      dispatch({
        type: calendarConstants.CHECK_GOOGLE_CALENDAR_LINKED_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: calendarConstants.CHECK_GOOGLE_CALENDAR_LINKED_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

export const store_google_calendar_token_action =
  (data) => async (dispatch) => {
    dispatch({
      type: calendarConstants.STORE_GOOGLE_CALENDAR_TOKEN_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.common.storeGoogleCalendarToken,
        data
      );
      if (response.status) {
        dispatch({
          type: calendarConstants.STORE_GOOGLE_CALENDAR_TOKEN_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarConstants.STORE_GOOGLE_CALENDAR_TOKEN_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

export const get_google_calendar_event_lists_action =
  (data) => async (dispatch) => {
    dispatch({
      type: calendarConstants.GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.common.getGoogleCalendarEventLists,
        data
      );
      if (response.status) {
        dispatch({
          type: calendarConstants.GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_SUCCESS,
          payload: response.data,
          // payload: data,
        });
        return response.data;
        // return data
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarConstants.GET_GOOGLE_CALENDAR_EVENT_LISTS_ACTION_FAILURE,
        payload: e.msg,
      });
      // showWarningMessage(e?.msg);
      return e;
    }
  };

export const get_calendar_scheduled_event_lists_timings_action =
  (id, date) => async (dispatch) => {
    dispatch({
      type: calendarConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.getCalendarScheduledEventsTimings.replace(
          ":id",
          id
        )}${date}/`
      );
      if (response.status) {
        dispatch({
          type: calendarConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_SUCCESS,
          payload: response.data,
          // payload: data,
        });
        return response.data;
        // return data
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_TIMINGS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };
